/* eslint-disable no-param-reassign, prefer-rest-params */
import angular from 'angular';
import ngRaven from 'ng-raven';
import uiRouter from 'angular-ui-router';
import restangular from 'restangular';
import auth0 from 'angular-auth0';
import oclazyload from 'oclazyload';
import angularTranslate from 'angular-translate';
import angularTranslateLoader from 'angular-translate-loader-static-files';
import ngSanitize from 'angular-sanitize';
import ngCvg from 'ng-csv';
import ngFileUpload from 'ng-file-upload';
import uiBootstrap from 'angular-ui-bootstrap';
import 'angular-summernote/dist/angular-summernote';
import 'angular-paging';
import '@iamadamjowett/angular-click-outside';
import 'ngstorage';
import 'angular-clipboard';
import ngCookies from 'angular-cookies';
import 'angular-drag-and-drop-lists';
import ngInfiniteScroll from 'ng-infinite-scroll';
import vsRepeat from 'angular-vs-repeat';
import ngHotjar from './shared/tracking/hotjar.module';

const isProduction = ENVIRONMENT === 'production';

const modules = [
    uiRouter,
    restangular,
    'ngStorage',
    angularTranslate,
    angularTranslateLoader,
    auth0,
    oclazyload,
    'angular-click-outside',
    ngSanitize,
    ngCvg,
    uiBootstrap,
    'bw.paging',
    'summernote',
    'angular-clipboard',
    ngCookies,
    ngFileUpload,
    'dndLists',
    ngInfiniteScroll,
    vsRepeat,
    ngHotjar,
];

if (isProduction) {
    modules.push(ngRaven);
}

angular.module('TALENYA-FE', modules);
